import React, { forwardRef } from 'react'
import s from './CustomDeliveryModal.module.css'
import Modal, { ModalRef } from 'components/common/Modal/Modal'
import { Button } from 'components/common'

interface Props {
  onCancel: () => void
  onConfirm: () => void
  children: React.ReactNode
  disableConfirmButton: boolean
  title: string
}

const CustomDeliveryModal = forwardRef<ModalRef, Props>(
  (
    {
      onCancel,
      onConfirm,
      children,
      disableConfirmButton,
      title = 'Delivery Address'
    },
    ref
  ) => {
    return (
      <Modal
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        showCloseIcon={false}
        ref={ref}
        className={s.addressModal}
      >
        <div className={s.addressModalWrapper}>
          <h4 className="mb-12 text-center text-3xl">{title}</h4>

          {children}

          <div className="flex justify-center mt-auto space-x-8 pb-4">
            <Button
              text="Confirm"
              onClick={onConfirm}
              disabled={disableConfirmButton}
              className="bg-green mt-4"
            />

            <Button
              text="Cancel"
              onClick={onCancel}
              className="mt-auto bg-red"
            />
          </div>
        </div>
      </Modal>
    )
  }
)

export default CustomDeliveryModal
